//* URL Produção
const api = process.env.REACT_APP_API_URL

export { api }